<template>
    <div>
        <DistributionDeliveryList userType="E" />
    </div>
</template>

<script>
import DistributionDeliveryList from '../../sale-management/delivery-list/distribution-delivery-list';

export default {
    name: 'inner-sale-list',
    components: {
        DistributionDeliveryList
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
